import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

const WordpressDownloadPlugin = () => {
    const [plugins, setPlugins] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState("all");
    const [loading, setLoading] = useState(true);

    /*
    |--------------------------------------------------------------------------
    | Fetch WordPress Plugins
    |--------------------------------------------------------------------------
    */

    useEffect(() => {
        fetch(
            "https://codebuddys.in/wp-json/wp/v2/wordpress_plugin?_embed&per_page=100"
        )
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Plugin API Error");
                }

                return res.json();
            })
            .then((data) => {
                setPlugins(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Plugin Fetch Error:", error);
                setLoading(false);
            });
    }, []);


    /*
    |--------------------------------------------------------------------------
    | Fetch WordPress Plugin Categories
    |--------------------------------------------------------------------------
    */

    useEffect(() => {
        fetch(
            "https://codebuddys.in/wp-json/wp/v2/wordpress-plugin-category?per_page=100"
        )
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Category API Error");
                }

                return res.json();
            })
            .then((data) => {
                setCategories(data);
            })
            .catch((error) => {
                console.error("Category Fetch Error:", error);
            });
    }, []);


    /*
    |--------------------------------------------------------------------------
    | Filter Plugins
    |--------------------------------------------------------------------------
    */

    const filteredPlugins =
        activeCategory === "all"
            ? plugins
            : plugins.filter((plugin) => {
                const terms =
                    plugin._embedded?.["wp:term"] || [];

                const allCategories = terms.flat();

                return allCategories.some(
                    (category) =>
                        Number(category.id) ===
                        Number(activeCategory)
                );
            });


    /*
    |--------------------------------------------------------------------------
    | Get Featured Image
    |--------------------------------------------------------------------------
    */

    const getImage = (plugin) => {
        return (
            plugin._embedded?.["wp:featuredmedia"]?.[0]
                ?.source_url ||
            ""
        );
    };


    /*
    |--------------------------------------------------------------------------
    | Get Categories
    |--------------------------------------------------------------------------
    */

    const getPluginCategories = (plugin) => {
        const terms =
            plugin._embedded?.["wp:term"] || [];

        return terms.flat();
    };


    /*
    |--------------------------------------------------------------------------
    | Strip HTML
    |--------------------------------------------------------------------------
    */

    const getDescription = (plugin) => {
        const description =
            plugin.excerpt?.rendered ||
            plugin.content?.rendered ||
            "";

        const div = document.createElement("div");

        div.innerHTML = description;

        return div.textContent || div.innerText || "";
    };


    return (
        <>
            <Header />
            <section className="wordpress-download-section">

                {/* =====================================================
                HEADER
                ===================================================== */}

                <div className="wordpress-download-header">

                    <h1>
                        WordPress Plugins
                    </h1>

                    <p>
                        Download our WordPress plugins and
                        enhance your website with powerful
                        features.
                    </p>

                </div>


                {/* =====================================================
                CATEGORY FILTER
                ===================================================== */}

                <div className="wordpress-plugin-categories" style={{ display: "none" }}>

                    <button
                        type="button"
                        className={
                            activeCategory === "all"
                                ? "active"
                                : ""
                        }
                        onClick={() =>
                            setActiveCategory("all")
                        }
                    >
                        All
                    </button>


                    {categories.map((category) => (
                        <button
                            type="button"
                            key={category.id}
                            className={
                                Number(activeCategory) ===
                                    Number(category.id)
                                    ? "active"
                                    : ""
                            }
                            onClick={() =>
                                setActiveCategory(
                                    category.id
                                )
                            }
                        >
                            {category.name}
                        </button>
                    ))}

                </div>


                {/* =====================================================
                LOADING
                ===================================================== */}

                {loading && (
                    <div className="wordpress-plugin-loading">
                        Loading plugins...
                    </div>
                )}


                {/* =====================================================
                NO PLUGINS (COMING SOON DESIGN)
                ===================================================== */}

                {!loading &&
                    filteredPlugins.length === 0 && (
                        <div className="wordpress-plugin-empty-card">
                            <div className="empty-icon-wrapper">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                </svg>
                            </div>
                            <h3>Exciting Plugins Coming Soon!</h3>
                            <p>We are currently crafting high-performance WordPress plugins to supercharge your web development. Stay tuned!</p>
                        </div>
                    )}


                {/* =====================================================
                PLUGIN GRID
                ===================================================== */}

                {!loading &&
                    filteredPlugins.length > 0 && (

                        <div className="wordpress-plugin-grid">

                            {filteredPlugins.map((plugin) => {

                                const image =
                                    getImage(plugin);

                                const pluginCategories =
                                    getPluginCategories(
                                        plugin
                                    );

                                const description =
                                    getDescription(
                                        plugin
                                    );

                                const zip =
                                    plugin.project_zip ||
                                    "";


                                return (
                                    <article
                                        className="wordpress-plugin-card"
                                        key={plugin.id}
                                    >

                                        {/* IMAGE */}

                                        <div className="wordpress-plugin-image">

                                            {image ? (
                                                <img
                                                    src={image}
                                                    alt={
                                                        plugin.title
                                                            ?.rendered ||
                                                        "WordPress Plugin"
                                                    }
                                                />
                                            ) : (
                                                <div className="wordpress-plugin-no-image">
                                                    WordPress Plugin
                                                </div>
                                            )}

                                        </div>


                                        {/* CONTENT */}

                                        <div className="wordpress-plugin-content">

                                            {/* CATEGORIES */}

                                            {pluginCategories.length >
                                                0 && (

                                                    <div className="wordpress-plugin-badges">

                                                        {pluginCategories.map(
                                                            (category) => (
                                                                <span
                                                                    key={
                                                                        category.id
                                                                    }
                                                                >
                                                                    {
                                                                        category.name
                                                                    }
                                                                </span>
                                                            )
                                                        )}

                                                    </div>

                                                )}


                                            {/* NAME */}

                                            <h2>
                                                {
                                                    plugin.title
                                                        ?.rendered
                                                }
                                            </h2>


                                            {/* DESCRIPTION */}

                                            <p>
                                                {description
                                                    ? description.substring(
                                                        0,
                                                        150
                                                    )
                                                    : "WordPress plugin with powerful features and easy-to-use functionality."}
                                            </p>


                                            {/* DOWNLOAD */}

                                            {zip ? (

                                                <a
                                                    href={zip}
                                                    className="wordpress-plugin-download"
                                                    download
                                                    target="_self"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span>
                                                        ↓
                                                    </span>

                                                    Download ZIP
                                                </a>

                                            ) : (

                                                <span className="wordpress-plugin-no-zip">
                                                    ZIP Not Available
                                                </span>

                                            )}

                                        </div>

                                    </article>
                                );
                            })}

                        </div>

                    )}


            </section>
            <Footer />
        </>
    );
};

export default WordpressDownloadPlugin;